import Swiper from 'swiper/dist/js/swiper';
import { Component } from '../core/component';

export class Slider extends Component {
    constructor() {
        super();
        this.selector = '.swiper-container';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            /* eslint-disable no-unused-vars */
            const slider = new Swiper(element, {
                spaceBetween: 40,
                centeredSlides: true,
                grabCursor: true,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    1030: {
                        spaceBetween: 20,
                    },
                    600: {
                        spaceBetween: 20,
                        centeredSlides: false,
                    },
                },
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/slider.js